<template>
  <div>
    <header class="register__header">
      <p
        v-if="!requestDone"
        class="register__title"
      >
        Inscription
      </p>
      <p
        v-else
        class="register__title register__title-blue"
      >
        Merci {{ formData.firstname }}
      </p>
    </header>
    <div
      v-if="!requestDone"
      class="main"
    >
      <div
        v-if="loading"
        class="backdrop"
      />
      <div class="u-d-f u-ai-c u-jc-sb">
        M'inscrire avec
        <span
          class="link"
          @click="loginModal.open()"
          >Déjà inscrit(e) ?</span
        >
      </div>
      <div
        class="hr"
        :class="{ 'is-loading': loading }"
      />
      <div class="o-row google-button-container">
        <div class="google-register-button"></div>
      </div>

      <div class="o-row">
        <div class="o-col u-12">
          <button
            class="btn btn-fb"
            @click="registerWithFacebook"
          >
            <img
              src="~/assets/icons/facebook.svg"
              alt="Facebook icon"
            />
            Facebook
          </button>
        </div>
      </div>
      <hr />
      <form
        ref="form"
        method="POST"
        autocomplete="off"
        @submit.prevent="checkForm"
      >
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <select
                id="civility"
                ref="civilityRef"
                v-model="formData.civility"
                name="civility"
                class="c-form__select"
                required
                :class="{ 'is-invalid': errors.civility }"
              >
                <option
                  value
                  disabled
                  selected
                >
                  Civilité
                </option>
                <option
                  v-for="gender in referential?.choiceGender"
                  :key="gender.value"
                  :value="gender.value"
                >
                  {{ gender.label }}
                </option>
              </select>
              <span
                v-if="errors.civility"
                class="c-form__feedback is-invalid"
              >
                {{ errors.civility }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="lastname"
                ref="lastnameRef"
                v-model="formData.lastname"
                autocomplete="family-name"
                type="text"
                name="lastname"
                class="c-form__control"
                placeholder="Nom*"
                required
                :class="{ 'is-invalid': errors.lastname }"
              />
              <span
                v-if="errors.lastname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.lastname }}
              </span>
            </div>
          </div>
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="firstname"
                ref="firstnameRef"
                v-model="formData.firstname"
                type="text"
                class="c-form__control"
                name="firstname"
                placeholder="Prénom*"
                autocomplete="given-name"
                required
                :class="{ 'is-invalid': errors.firstname }"
              />
              <span
                v-if="errors.firstname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.firstname }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="email"
                ref="emailRef"
                v-model="formData.email"
                type="email"
                name="email"
                class="c-form__control"
                placeholder="Adresse e-mail*"
                autocomplete="email"
                required
                :class="{ 'is-invalid': errors.email }"
              />
              <span
                v-if="errors.email"
                class="c-form__feedback is-invalid"
              >
                {{ errors.email }}
              </span>
            </div>
          </div>
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="password"
                ref="passwordRef"
                v-model="formData.password"
                type="password"
                class="c-form__control"
                name="password"
                placeholder="Mot de passe*"
                autocomplete="new-password"
                required
                :class="{
                  'is-invalid': errors.password || errors.password_confirmation,
                }"
              />
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="password_confirmation"
                ref="password_confirmationRef"
                v-model="formData.password_confirmation"
                type="password"
                class="c-form__control"
                name="password_confirmation"
                autocomplete="new-password"
                placeholder="Confirmer le mot de passe*"
                required
                :class="{
                  'is-invalid': errors.password || errors.password_confirmation,
                }"
              />
            </div>
          </div>
        </div>
        <div
          class="text-small u-mb-3"
          :class="{
            'is-invalid': errors.password || errors.password_confirmation,
          }"
        >
          <span v-if="errors.password">{{ errors.password }} <br /></span>
          <span v-if="errors.password_confirmation">
            {{ errors.password_confirmation }} <br />
          </span>
          8 caractères minimum. Au moins une majuscule et un caractère spécial.
        </div>
        <div class="o-row">
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-3">
              <input
                id="nickname"
                ref="nicknameRef"
                v-model="formData.nickname"
                type="text"
                class="c-form__control"
                name="nickname"
                placeholder="Pseudo*"
                autocomplete="nickname"
                required
                :class="{ 'is-invalid': errors.nickname }"
              />
              <span
                v-if="errors.nickname"
                class="c-form__feedback is-invalid"
              >
                {{ errors.nickname }}
              </span>
            </div>
          </div>
          <div class="o-col u-12 u-6@tb">
            <div class="c-form__group u-mb-5">
              <input
                id="psnId"
                ref="psnIdRef"
                v-model="formData.psnId"
                type="text"
                class="c-form__control"
                name="psnId"
                placeholder="PSN ID (facultatif)"
                :class="{ 'is-invalid': errors.psnId }"
              />
              <span
                v-if="errors.psnId"
                class="c-form__feedback is-invalid"
              >
                {{ errors.psnId }}
              </span>
            </div>
          </div>
        </div>
        <div class="u-mb-5">
          <p
            ref="birthday"
            class="u-mb-3"
          >
            Votre date de naissance*
          </p>
          <div class="o-row">
            <div class="o-col u-3">
              <div class="c-form__group">
                <select
                  id="day"
                  v-model="formData.birthData.day"
                  name="day"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    JJ
                  </option>
                  <option
                    v-for="day in days"
                    :key="day"
                    :value="day"
                  >
                    {{ day }}
                  </option>
                </select>
              </div>
            </div>
            <div class="o-col u-3">
              <div class="c-form__group">
                <select
                  id="month"
                  v-model="formData.birthData.month"
                  name="month"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    MM
                  </option>
                  <option
                    v-for="month in months"
                    :key="month"
                    :value="month"
                  >
                    {{ month }}
                  </option>
                </select>
              </div>
            </div>
            <div class="o-col u-6">
              <div class="c-form__group">
                <select
                  id="year"
                  v-model="formData.birthData.year"
                  name="year"
                  class="c-form__select"
                  required
                  :class="{ 'is-invalid': errors.birthday }"
                >
                  <option
                    value
                    disabled
                    selected
                  >
                    AAAA
                  </option>
                  <option
                    v-for="year in years"
                    :key="year"
                    :value="year"
                  >
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
            <div
              v-if="errors.birthday"
              class="o-col u-12"
            >
              <span class="c-form__feedback is-invalid">
                {{ errors.birthday }}
              </span>
            </div>
          </div>
        </div>
        <div>
          <p class="u-mb-3">Votre code d'inscription</p>
          <div class="c-form__group u-mb-3">
            <input
              id="bonusCode"
              ref="bonusCodeRef"
              v-model="formData.bonusCode"
              type="text"
              class="c-form__control"
              name="bonusCode"
              placeholder="Votre code bonus (facultatif)"
              :class="{ 'is-invalid': errors.bonusCode }"
            />
            <span
              v-if="errors.bonusCode"
              class="c-form__feedback is-invalid"
            >
              {{ errors.bonusCode }}
            </span>
          </div>
        </div>
        <p class="text-small u-mb-4">* champs obligatoires</p>
        <hr />
        <div class="u-mb-4">
          <div class="news__group">
            <img
              src="~/assets/icons/news-alt.svg"
              alt="Newsletter icon"
              width="32"
              height="32"
            />
            <span class="news news--alt">
              Évaluez vos chances de gagner des bons d’achat !
            </span>
          </div>
          <div class="c-form__group">
            <div class="c-form__check u-ai-fs">
              <input
                id="wapNewsletter"
                v-model="formData.wapNewsletter"
                class="c-form__check-input"
                type="checkbox"
                name="wapNewsletter"
              />
              <label
                class="c-form__check-label"
                for="wapNewsletter"
              >
                J'accepte de recevoir chaque mois des emails m'informant du
                classement sur We Are PlayStation afin d'évaluer mes chances de
                remporter des bons d'achat.
              </label>
            </div>
          </div>
        </div>
        <div class="u-mb-4">
          <div class="news__group">
            <img
              src="~/assets/icons/news.svg"
              alt="News icon"
              width="32"
              height="32"
            />
            <span class="news">
              Soyez au courant de toute l'actualité PlayStation
            </span>
          </div>
          <div class="c-form__group">
            <div class="c-form__check u-ai-fs">
              <input
                id="sonyPlaystationNewsletter"
                v-model="formData.sonyPlaystationNewsletter"
                class="c-form__check-input"
                type="checkbox"
                name="sonyPlaystationNewsletter"
              />
              <label
                class="c-form__check-label"
                for="sonyPlaystationNewsletter"
              >
                J'accepte de recevoir des informations et des offres
                personnalisées par e-mail concernant PlayStation® et Sony de la
                part de Sony Interactive Entertainment Europe Limited.
              </label>
            </div>
          </div>
        </div>
        <hr class="u-mb-4" />
        <div class="o-row">
          <div class="o-col u-12 u-auto@tb u-mb-3 u-mb-0@tb">
            <RecaptchaCheckbox
              @error="onError()"
              @success="onSuccess()"
              @expired="onExpired()"
            />
            <p
              v-if="errors.recaptcha"
              class="is-invalid"
            >
              {{ errors.recaptcha }}
            </p>
          </div>
          <div class="o-col u-d-f u-ai-fe u-jc-fe">
            <ButtonSimple
              type="submit"
              label="S'inscrire"
              :disabled="loading"
            />
          </div>
        </div>
        <div>
          <p class="mentions">
            En cliquant sur « S'inscrire », vous confirmez avoir lu, compris et
            accepté les
            <NuxtLink
              to="/page/conditions-dutilisation"
              class="u-c-reset"
              target="_blank"
              >conditions générales d'utilisation</NuxtLink
            >
            de We Are PlayStation. Vos informations seront stockées selon notre
            <NuxtLink
              to="/page/politique-de-confidentialite"
              class="u-c-reset"
              target="_blank"
              >politique de confidentialité</NuxtLink
            >.
          </p>
        </div>
      </form>
    </div>
    <div v-else>
      <p>
        Un email de confirmation d'inscription vient de vous être envoyé.
        Cliquez sur le lien pour valider votre inscription.
        <br />
        <br />
        <strong>Attention, ce lien n'est valide que 48h.</strong>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ValidationError } from 'yup'
import { loginModal } from '~/modals/login'
import { googleAuthCallback } from '~/utils/api'
import { registrationFormSchema } from '~/utils/validations'

type ErrorKeys = keyof typeof errors.value
type ErrorPath = ErrorKeys | undefined

const props = withDefaults(defineProps<{ referrer: string }>(), {
  referrer: '',
})

const { renderButton } = useGoogleAuth({
  initializeConfig: {
    callback: googleAuthCallback,
  },
})

renderButton({
  selector: '.google-register-button',
  config: {
    theme: 'outline',
    size: 'large',
    width: 468,
  },
})

const referentialStore = useReferentialStore()
const { referential } = storeToRefs(referentialStore)

const errorsYup = {
  civility: '',
  lastname: '',
  firstname: '',
  email: '',
  password: '',
  password_confirmation: '',
  nickname: '',
  birthday: '',
  psnId: '',
  bonusCode: '',
}

const requestDone = ref(false)
const loading = ref(false)
const recaptchaSuccess = ref(false)

const formData = reactive({
  civility: '',
  lastname: '',
  firstname: '',
  email: '',
  password: '',
  password_confirmation: '',
  nickname: '',
  psnId: '',
  birthData: {
    day: '',
    month: '',
    year: '',
  },
  birthday: '',
  bonusCode: '',
  wapNewsletter: false,
  sonyPlaystationNewsletter: false,
})

const errors = ref<Partial<typeof errorsYup & { recaptcha?: string }>>({})

const civilityRef = ref<HTMLElement | null>(null)
const lastnameRef = ref<HTMLElement | null>(null)
const firstnameRef = ref<HTMLElement | null>(null)
const emailRef = ref<HTMLElement | null>(null)
const passwordRef = ref<HTMLElement | null>(null)
const passwordConfirmationRef = ref<HTMLElement | null>(null)
const nicknameRef = ref<HTMLElement | null>(null)
const psnIdRef = ref<HTMLElement | null>(null)
const birthdayRef = ref<HTMLElement | null>(null)
const bonusCodeRef = ref<HTMLElement | null>(null)
const recaptchaRef = ref<HTMLElement | null>(null)

const refs = {
  civility: civilityRef,
  lastname: lastnameRef,
  firstname: firstnameRef,
  email: emailRef,
  password: passwordRef,
  password_confirmation: passwordConfirmationRef,
  nickname: nicknameRef,
  psnId: psnIdRef,
  birthday: birthdayRef,
  bonusCode: bonusCodeRef,
  recaptcha: recaptchaRef,
}

const { gtag } = useGtag()
const crossContentStore = useCrossContentStore()
const popoutStore = usePopoutStore()
const { bonusPointsWhenRegistering } = popoutStore

const checkForm = async () => {
  loading.value = true

  gtag('event', 'clic_popup_form_inscrip', {
    cta_name: `S'inscrire`,
  })

  const validations = {
    form: false,
    recaptcha: false,
  }

  // Start form validation
  formData.birthday = `${formData.birthData.year}-${formData.birthData.month}-${formData.birthData.day}`

  try {
    await registrationFormSchema.validate(formData, {
      abortEarly: false,
    })
    errors.value = {
      ...errors.value,
      ...errorsYup,
    }

    validations.form = true
  } catch (err) {
    const error = err as ValidationError
    loading.value = false

    // Re-init errors
    errors.value = {
      ...errors.value,
      ...errorsYup,
    }

    errors.value = {}
    let path: keyof typeof errors.value

    error.inner.forEach((innerError) => {
      const innerErrorPath = innerError.path as keyof typeof errors.value
      if (!path) {
        path = innerErrorPath
      }
      if (innerError.path) {
        errors.value[innerErrorPath] = innerError.message
      }

      if (path) {
        refs[path].value?.scrollIntoView(false)
        nextTick(() => {
          window.scrollBy(0, -90)
        })
      }
    })
  }

  if (recaptchaSuccess.value) {
    // Valid the recaptcha before continue
    validations.recaptcha = true
  } else {
    loading.value = false
    errors.value.recaptcha = 'Veuillez valider le captcha'

    return
  }

  if (!validations.form || !validations.recaptcha) {
    loading.value = false

    return
  }

  // All is good, call the WS
  // try {
  const formBody = {
    email: formData.email,
    password: {
      first: formData.password,
      second: formData.password_confirmation,
    },
    civility: formData.civility,
    firstname: formData.firstname,
    lastname: formData.lastname,
    nickname: formData.nickname,
    psnId: formData.psnId,
    birthday: { ...formData.birthData },
    bonusCode: formData.bonusCode,
    wapNewsletter: formData.wapNewsletter,
    sonyPlaystationNewsletter: formData.sonyPlaystationNewsletter,
    referrer: undefined as string | undefined,
    bonusPoint: bonusPointsWhenRegistering,
  }

  if (sessionStorage.getItem('referrer')) {
    formBody['referrer'] = props.referrer
    crossContentStore.setReferrer('')
    sessionStorage.removeItem('referrer')
  }

  const { error } = await useCustomFetch(API.POST__REGISTER, {
    method: 'POST',
    body: formBody,
  })

  if (error.value) {
    const { data, statusCode } = error.value

    if (statusCode && statusCode <= 400 && statusCode < 500) {
      const { errors: responseErrors } = data

      let path: ErrorPath

      Object.keys(responseErrors).forEach((key) => {
        if (!path) {
          path = key as ErrorKeys
        }
        errors.value[path] = responseErrors[path].join(' ')
      })

      if (path && refs[path]) {
        refs[path].value?.scrollIntoView(true)
        nextTick(() => {
          window.scrollBy(0, -90)
        })
      }
    }
    loading.value = false
    return
  }

  // Verify the response of register WS
  // If good, display the confirmation block
  requestDone.value = true

  gtag('event', 'popupPage', {
    popupName: '/popup/inscription/confirmation',
  })

  scrollMeTo('signin')

  loading.value = false
}

const onError = () => {
  errors.value.recaptcha = 'Veuillez valider le captcha'
}

const onSuccess = () => {
  recaptchaSuccess.value = true
  errors.value.recaptcha = ''
}

const onExpired = () => {
  errors.value.recaptcha = 'Veuillez valider le captcha'
}

const instance = getCurrentInstance()

const scrollMeTo = (refName: string) => {
  if (!instance?.parent?.refs) return
  const element = instance.parent.refs[refName] as HTMLElement

  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - 190,
    behavior: 'smooth',
  })
}

const registerWithFacebook = async () => {
  loading.value = true
  gtag('event', 'clic_popup_form_inscrip', {
    cta_name: `Facebook`,
  })

  const { $FB } = useNuxtApp()
  $FB.getLoginStatus((response) => {
    if (response.status === 'connected') {
      // connected
      loginFb()
    } else {
      // not_authorized
      $FB.login(
        (response) => {
          if (response.authResponse) {
            loginFb()
          } else {
            loading.value = false
          }
        },
        { scope: 'email' },
      )
    }
  })
}

const loginFb = async () => {
  const { $FB } = useNuxtApp()

  loading.value = true
  try {
    $FB.api(
      '/me?fields',
      { fields: 'id,first_name,last_name,email' },
      (response) => {
        const { first_name: firstname, last_name: lastname, email } = response

        formData.firstname = firstname
        formData.lastname = lastname
        formData.email = email
      },
    )
  } catch (err) {
    console.error(err)
    loading.value = false
  }

  loading.value = false
}
</script>

<style lang="scss" scoped>
.main {
  position: relative;
}

.google-button-container {
  display: flex;
  justify-content: center;

  .google-register-button {
    display: flex;
    justify-content: center;
    height: 40px;
    margin-bottom: 1.6rem;
  }
}

hr {
  margin: 1.5rem 0;
  border-bottom: 0;
  opacity: 0.15;
}

.hr {
  position: relative;
  height: 1px;
  margin: 1.5rem 0;
  overflow: hidden;
  background-color: rgb(0 0 0 / 0.15);

  &.is-loading {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -25%;
      display: block;
      width: 25%;
      height: 100%;
      background-color: $blue;
      animation: loading 0.7s infinite linear;
    }
  }
}

.register {
  &__header {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3rem;

    @media (min-width: 992px) {
      margin-bottom: 4rem;
    }
  }

  &__title {
    font-size: 2.6rem;
    line-height: 1.15;

    @media (min-width: 992px) {
      font-size: 3.2rem;
    }

    &-blue {
      color: #0072ce;
    }
  }
}

.backdrop {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  background-color: transparent;
}

.link {
  font-size: 1.4rem;
  cursor: pointer;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: $dark;
    transition: background 0.35s ease-in-out;
  }

  &:hover::after {
    background-color: transparent;
  }
}

.text-small {
  font-size: 1.2rem;
}

.mentions {
  margin-top: 6rem;
  font-size: 1.2rem;
  line-height: 1.25;
  opacity: 0.4;
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 4.6rem;

  &-fb {
    color: #fff;
    background-color: #1976f2;
    border: 0;
  }

  &-go {
    color: #808080;
    background-color: #fff;
    border: 1px solid #cbcbcb;
  }

  img,
  svg {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 1rem;
  }
}

.news__group {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}

.news {
  margin-left: 1rem;
  color: $blue;
  font-family: 'SST Condensed';
  font-size: 1.6rem;
  font-weight: 500;

  &--alt {
    color: $orange;
  }

  .points {
    margin-right: 0.6rem;
    color: $orange;
    font-size: 1.9rem;
    font-weight: 700;

    span {
      font-size: 1.1rem;
      text-transform: uppercase;
    }
  }
}

.is-invalid {
  color: #ea5151;
}

@keyframes loading {
  0% {
    left: -25%;
  }

  90%,
  100% {
    left: 100%;
  }
}

// Overrides
.c-form__check {
  margin-left: 4.2rem;
}

.c-form__check-label {
  line-height: 1.25;
}
</style>
